import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { debounce } from 'lodash';


import { Pagination, Autoplay } from "swiper";

import { Box, styled, useMediaQuery } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import StatesContext from "../../context/StatesContext";
import { useCreateClicksMutation, useCreateImpressionsMutation } from "../../helpers/StatisticsApi";


const PortfolioSlider = ({ data }) => {

    const myRef = useRef(null);


    const context = useContext(StatesContext)
    const { darkToggle } = context

    const [id, setid] = useState('')


    const [createImpression, res] = useCreateImpressionsMutation()
    const [createClicks, resClicks] = useCreateClicksMutation()

    const [activeSlide, setActiveSlide] = useState();
    const [initialSlide, setinitialSlide] = useState(0)

    const StyledPortfolioSection = styled(Box)(({ theme }) => ({

        '.swiper-pagination-bullet-active-next': {
            backgroundColor: darkToggle && 'white !important',
            opacity: '0.5'
        },
        '.swiper-pagination-bullet-active-prev': {
            backgroundColor: darkToggle && 'white !important',
            opacity: '0.5'
        },
        '.swiper-pagination-bullet': {
            backgroundColor: darkToggle ? 'white' : '#424242',
            opacity: darkToggle && '0.5'
        },
        '.swiper-pagination': {
            position: 'absolute',
            top: !smallerthen768 ? '-8px' : '0px',
            zIndex: '-1'
        },
        '.swiper-pagination-bullet-active': {
            backgroundColor: '#1976d2 !important',
            opacity: '1 !important'
        },

    }))

    const handleSlideChange = debounce((swiper) => {
        setActiveSlide(swiper.realIndex);
    }, 700);


    const smallerthen768 = useMediaQuery('(max-width:768px)')

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                // call your function here
                if (localStorage.getItem('areaDetails')) {
                    const locationObj = JSON.parse(localStorage.getItem('areaDetails'));

                    const userId = locationObj.userId;
                    const countryName = locationObj.countryName;
                    const city = locationObj.city;
                    const postal = locationObj.postal;
                    const ip = locationObj.ip;
                    const region = locationObj.region;
                    const capital = locationObj.country_capital;
                    const deviceType = locationObj.deviceType;
                    const latitude = locationObj.latitude;
                    const longitude = locationObj.longitude;

                    createImpression({ data, userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude })
                }
            }
        });
        observer.observe(myRef.current);
        return () => {
            observer.disconnect();
        };
    }, []);


    const handleClick = (e, item) => {

        if (localStorage.getItem('areaDetails')) {
            const locationObj = JSON.parse(localStorage.getItem('areaDetails'));
            const userId = locationObj.userId;
            const countryName = locationObj.countryName;
            const city = locationObj.city;
            const postal = locationObj.postal;
            const ip = locationObj.ip;
            const region = locationObj.region;
            const capital = locationObj.country_capital;
            const deviceType = locationObj.deviceType;
            const latitude = locationObj.latitude;
            const longitude = locationObj.longitude;

            let id = item._id

            createClicks({ userId, countryName, city, postal, id, ip, region, capital, deviceType, latitude, longitude })

        }

    }


    return (
        <div ref={myRef} >
            <div className="lg:w-[80%] mx-auto mt-8 ">
                <StyledPortfolioSection>
                    <Swiper
                        onSlideChange={handleSlideChange}
                        initialSlide={activeSlide}
                        modules={[Pagination, Autoplay]}
                        pagination={{
                            clickable: true,
                            dynamicBullets: smallerthen768 ? true : false
                        }}
                        autoplay={{
                            pauseOnMouseEnter: true
                        }}

                        speed={1000}
                        style={{
                            "--swiper-navigation-size": "25px",
                            position: 'relative',
                            padding: '30px 0'
                        }}
                    >
                        {data.map((item, i) => (
                            <SwiperSlide key={i}>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-7"
                                    onClick={(e) => handleClick(e, item)}
                                  
                                >

                                    <div className={'w-[100%] md:w-[90%] mx-auto '}>
                                        <Swiper
                                            modules={[Autoplay]}

                                            autoplay={
                                                smallerthen768
                                                    ? undefined // Pass undefined to disable autoplay
                                                    : {
                                                        pauseOnMouseEnter: true, delay: 1200
                                                    }
                                            }
                                            spaceBetween={smallerthen768 ? 5 : 20}
                                            speed={1200}
                                            style={{
                                                "--swiper-navigation-size": "25px",
                                            }}
                                        >
                                            {item.img.map((value, i) => (
                                                <SwiperSlide key={i}

                                                >
                                                    <div onClick={() => window.open(item.link)} className='relative'>
                                                        <img src={value} alt='img'

                                                            className={`md:w-full w-[90%] hover:scale-95 hover:shadow-lg duration-700 shadow-md  mx-auto h-[250px] sm:h-[300px] rounded-[25px]`} />

                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>


                                    <div className="px-3">
                                        <h2 className="md:pt-50px font-bold text-[18px] sm:text-xl dark:text-white">{item.title}</h2>

                                        <p className={`text-[12px] sm:text-[16px] text-gray-500 dark:text-gray-300 mt-1`}>
                                            {item.desc}
                                        </p>
                                        <div className="flex mt-3 md:justify-end">
                                            <button
                                                onClick={() => window.open(item.link)}
                                                className="relative inline-flex items-center px-7 py-1.5 overflow-hidden text-xs font-medium text-black dark:text-white border-2 border-black dark:border-yellow-500 rounded-full hover:text-white group hover:bg-gray-50 dark:hover:bg-yellow-500">
                                                <span className="absolute left-0 block w-full h-0 transition-all bg-gray-800 dark:bg-yellow-500 opacity-100 group-hover:h-full top-1/2 group-hover:top-0 duration-400 ease"></span>
                                                <span className="absolute right-0 flex items-center justify-start w-6 h-10 duration-300 transform translate-x-full group-hover:translate-x-0 ease">
                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                                                </span>
                                                <span className="relative">Live Preview</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </StyledPortfolioSection>
            </div>
        </div>
    )
}

export default PortfolioSlider